import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './config/authConfig';
import { BrowserRouter } from 'react-router-dom';

export const msalInstance = new PublicClientApplication(msalConfig);
//g
ReactDOM.render(
  <React.StrictMode>
    <Redirect />
    <BrowserRouter basename="/app">
      <App msalInstance={msalInstance} />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

function Redirect() {
  useEffect(() => {
    if (!window.location.pathname.startsWith("/app")) {
      window.location.href = process.env.REACT_APP_LANDING_PAGE || "https://www.axionenergy.com/Paginas/negocios/onpwa.aspx";
    }
  }, []);

  return null;
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// TODO: Evaluate whether this auth-only PWA should unregister the service worker
// to avoid stale cached auth shell assets after deployments. Keeping register()
// preserves the original PWA behavior for now.
serviceWorkerRegistration.register();
